// src/services/avatarIdb.js
// Very small IndexedDB wrapper for avatar blobs.
// DB: 'eh-media-cache'  |  Store: 'avatars'  |  Key: <cacheKey> (e.g. peer u_id or mxc URL)

const DB_NAME = 'eh-media-cache';
const STORE = 'avatars';
const DB_VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const os = db.createObjectStore(STORE, { keyPath: 'key' });
        os.createIndex('updatedAt', 'updatedAt', { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(storeMode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, storeMode);
    const s = t.objectStore(STORE);
    const done = (v) => { resolve(v); db.close(); };
    t.oncomplete = () => done(undefined);
    t.onerror = () => reject(t.error);
    fn(s, done);
  });
}

export async function idbGetAvatar(key) {
  return tx('readonly', (s, done) => {
    const r = s.get(key);
    r.onsuccess = () => done(r.result || null);
  });
}

export async function idbPutAvatar(record) {
  // record: { key, blob, mime, updatedAt }
  return tx('readwrite', (s, done) => {
    s.put(record);
  });
}

export async function idbPruneOlderThan(ms) {
  const cutoff = Date.now() - ms;
  return tx('readwrite', (s, done) => {
    const idx = s.index('updatedAt');
    const req = idx.openCursor();
    req.onsuccess = () => {
      const cur = req.result;
      if (!cur) return;
      if (cur.value.updatedAt < cutoff) s.delete(cur.primaryKey);
      cur.continue();
    };
  });
}
